import ServerError from './ServerError';
import type { FriendlyErrorResponse } from './types';

export default class IdleError extends ServerError {
  constructor(error: FriendlyErrorResponse) {
    super(error);

    this.name = 'IdleError';
  }
}
